import { makeAutoObservable } from "mobx";

interface IConfirmationModalOptions {
  title?: string;
  description?: string;
  cancelText?: string;
  confirmText?: string;
  onCancel?: () => void;
  onConfirm?: () => Promise<void>;
}

export class ConfirmationModalStore {
  isOpen = false;

  options: IConfirmationModalOptions | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  open(options: IConfirmationModalOptions) {
    this.isOpen = true;
    this.options = options;
  }

  close() {
    this.isOpen = false;
    setTimeout(() => {
      this.options = null;
    }, 500);
  }

  reset() {
    this.isOpen = false;
    this.options = null;
  }
}
